import { Query } from '../../hooks/queries'
import { useContrastQuery } from '../../hooks/use-contrast-query'
import { AgentFeature } from '.'
import { getAgentFeatures } from '../../api/queries/agent-features/agent-features'

export function useAgentFeatures() {
  return useContrastQuery<undefined, AgentFeature[]>(
    [Query.AGENT_FEATURES],
    getAgentFeatures,
    undefined,
    { notifyOnChangeProps: 'tracked' }
  )
}
